module.exports = __webpack_public_path__ + "img/close.cad70081.svg";